import type { WorkItem } from '../types/work';

export const workItems: WorkItem[] = [
  {
    id: 'kordis',
    title: 'Kordis: an AI CFO whose numbers you can check',
    role: 'PM + Lead Design · 2026',
    summary:
      'Finance leaders need answers they can verify. Inline citations, confidence in plain words and clarifying questions make every AI answer checkable.',
    tags: ['Agentic AI', 'Conversational UX', 'Trust'],
    variant: 'kordis',
    label: 'AI finance',
    href: '/work/kordis',
    locked: true,
    image: {
      src: 'https://cdn.magicpatterns.com/uploads/pRTk5yuKhWyq7gUsdzS1ef/Macbook_Air_-_Dark_Background.png',
      alt: 'Kordis AI CFO on a MacBook asking "What should we look into?", beside a chat answer about cash runway with cited sources',
      fit: 'contain',
      background: '#1C202B',
    },
  },
  {
    id: 'clear-docs',
    title: "Clear Docs Mobile: deciding what loan officers don't need on a phone",
    role: 'Senior Product Designer · CI&T · 2026',
    summary:
      'Incomplete requirements and a dense desktop tool. I compared the old design with what desktop actually does, then scoped mobile to accept, reject, archive and tag. In progress.',
    tags: ['Mobile', 'Scoping', 'Mortgage lending'],
    variant: 'cleardocs',
    image: {
      src: 'https://cdn.magicpatterns.com/uploads/xoynLAKLt7yCWwvC7Ycjse/Case_Study_Thumbnail1x_(1).png',
      alt: 'Clear Docs mobile: the document list with items needing review, beside the document viewer with the Categorize Document sheet open',
      fit: 'contain',
      background: '#0F393C',
    },
    label: 'Mortgage lending',
    href: '/work/clear-docs',
    locked: true,
    stat: { value: '16 areas', label: 'audited before deciding mobile scope' },
  },
  {
    id: 'botkeeper',
    title: 'Botkeeper: cutting time to edit a user by 34%',
    role: 'Senior AI Product Designer · 2025',
    summary:
      'Redesigned user and permission management for an AI bookkeeping platform, so accountants spend less time on admin.',
    tags: ['B2B SaaS', 'Accounting tech', 'Usability testing'],
    variant: 'botkeeper',
    stat: { value: '−34%', label: 'time to edit a user' },
  },
  {
    id: 'palacio',
    title: 'Palacio de Hierro: luxury shopping and credit in one app',
    role: 'UX Lead, credit · 2023',
    summary:
      'Retail and an in-store-only credit card, brought into one app in 11 months. A neutral home screen ended the turf war between marketing and credit.',
    tags: ['Luxury retail', 'Fintech', 'iOS & Android'],
    variant: 'palacio',
    href: '/work/palacio-de-hierro',
    image: {
      src: 'https://cdn.magicpatterns.com/uploads/gGdhBywRA6pPqcPvdAUNJN/Group_694356621.png',
      alt: 'Palacio de Hierro credit app: the Tarjetas Palacio home and the Más opciones menu, beside a brand campaign photo',
      fit: 'cover',
    },
    stat: { value: '50K+', label: 'downloads · 4.6 on the app stores' },
  },
  {
    id: 'vendoo',
    title: 'Vendoo: an analytics dashboard resellers could do taxes with',
    role: 'Lead Product Designer · 2020–2021',
    summary:
      'As the only designer, I built the design process and metrics, then shipped CSV export, a business analytics dashboard and a design system.',
    tags: ['Data visualization', 'SaaS', 'Design system'],
    variant: 'vendoo',
    image: {
      src: 'https://cdn.magicpatterns.com/uploads/7eqckkCHZme4b1zzwrDxSe/aaaaa.png',
      alt: 'Vendoo analytics dashboard on a tablet: date range filters, revenue and profit chart, and an overview of sold and listed items',
      fit: 'cover',
    },
    href: '/work/vendoo',
    stat: { value: '3+ years', label: 'in production as the reseller analytics hub' },
  },
];
